module.exports = function getResource(label, vars = []) {
    const resources = { seeAll: `See all ${vars[0]}` };

    return resources[label];
};
